import PropTypes from "prop-types";
import EditAdmin from "layouts/super_admin/admin/modals/EditAdmin";
import EditAnnotator from "layouts/admin/annotator/modals/EditUser";

export default function EditUser({ user, ...props }) {
  if (user?.role === "Admin") {
    return <EditAdmin user={user} {...props} />;
  }
  return <EditAnnotator user={user} {...props} />;
}

EditUser.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  user: PropTypes.object,
  onSuccess: PropTypes.func,
  title: PropTypes.string,
  successMessageKey: PropTypes.string,
};

EditUser.defaultProps = {
  user: null,
  onSuccess: undefined,
  title: null,
  successMessageKey: null,
};
